export const COMPANY_COLORS = [
  "#3B82F6", "#10B981", "#A78BFA", "#F59E0B", "#FF6B6B", "#3B82F6", "#EC4899", "#14B8A6", "#F97316", "#8B5CF6",
];

export function colorForId(id) {
  let h = 0;
  for (let i = 0; i < (id || "").length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return COMPANY_COLORS[h % COMPANY_COLORS.length];
}

// Resolve a company's display color: explicit theme accent, else deterministic.
export function companyColor(accent, id) {
  return accent || colorForId(id);
}
